module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('div', {
    attrs: {
      "id": "page-wrapper"
    }
  }, [_vm._m(0), " ", " ", _vm._m(1), " ", " ", _vm._m(2), " ", " ", _vm._m(3), " ", " ", " ", _h('departure'), " ", _h('tier'), " ", _h('themes')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('header', {
    staticClass: "alt",
    attrs: {
      "id": "header"
    }
  }, [_h('h1', [_h('a', {
    attrs: {
      "href": "index.html"
    }
  }, ["Escape this Weekend"])]), " ", _h('nav', [_h('a', {
    attrs: {
      "href": "#menu"
    }
  }, ["Menu"])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('nav', {
    attrs: {
      "id": "menu"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h2', ["Menu"]), " ", _h('ul', {
    staticClass: "links"
  }, [_h('li', [_h('a', {
    attrs: {
      "href": "index.html"
    }
  }, ["Home"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "generic.html"
    }
  }, ["Generic"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "elements.html"
    }
  }, ["Elements"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["Log In"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["Sign Up"])])]), " ", _h('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    }
  }, ["Close"])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "banner"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h2', ["Take off this Weekend "]), " ", _h('p', ["10.000+ destinations. chosen for you. ready to go."]), " ", _h('div', {
    staticClass: "logo"
  }, [_h('span', {
    staticClass: "icon fa-plane"
  }), " ", _h('span', {
    staticClass: "icon fa-bus"
  }), " ", _h('span', {
    staticClass: "icon fa-bed"
  }), " ", _h('span', {
    staticClass: "icon fa-suitcase"
  }), " ", _h('span', {
    staticClass: "icon fa-tree"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "wrapper"
    }
  }, [_h('section', {
    staticClass: "wrapper spotlight style1",
    attrs: {
      "id": "one"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic01.jpg"),
      "alt": ""
    }
  })]), " ", _h('div', {
    staticClass: "content"
  }, [_h('h2', {
    staticClass: "major"
  }, ["The best deals"]), " ", _h('p', ["No time to waste? We find out the best deals out there so you don't have to. We apply smart search algorithms to the best partners on transport, accomodation and services, and find weekend packages which fit your taste and budget, providing the best value in the industry."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])])])]), " ", " ", _h('section', {
    staticClass: "wrapper alt spotlight style2",
    attrs: {
      "id": "two"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic02.jpg"),
      "alt": ""
    }
  })]), " ", _h('div', {
    staticClass: "content"
  }, [_h('h2', {
    staticClass: "major"
  }, ["Always Shining"]), " ", _h('p', ["Our smart engine automatically filters out destinations where the weather is going to be bad"]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])])])]), " ", " ", _h('section', {
    staticClass: "wrapper spotlight style3",
    attrs: {
      "id": "three"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic03.jpg"),
      "alt": ""
    }
  })]), " ", _h('div', {
    staticClass: "content"
  }, [_h('h2', {
    staticClass: "major"
  }, ["Full Package"]), " ", _h('p', ["We organize everything, and our concierge will always be available to help over the phone. We provide full package* to you including transportation from your door, to the destination, and back."]), " ", _h('p', ["*Including services like Uber, Taxi, Bus, Flights and Accomodation."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])])])]), " ", " ", _h('section', {
    staticClass: "wrapper alt style1",
    attrs: {
      "id": "four"
    }
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h2', {
    staticClass: "major"
  }, ["Testimonials"]), " ", _h('p', ["Cras mattis ante fermentum, malesuada neque vitae, eleifend erat. Phasellus non pulvinar erat. Fusce tincidunt, nisl eget mattis egestas, purus ipsum consequat orci, sit amet lobortis lorem lacus in tellus. Sed ac elementum arcu. Quisque placerat auctor laoreet."]), " ", _h('section', {
    staticClass: "features"
  }, [_h('article', [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic04.jpg"),
      "alt": ""
    }
  })]), " ", _h('h3', {
    staticClass: "major"
  }, ["Sed feugiat lorem"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla dignissim dapibus ultrices."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])]), " ", _h('article', [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic05.jpg"),
      "alt": ""
    }
  })]), " ", _h('h3', {
    staticClass: "major"
  }, ["Nisl placerat"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla dignissim dapibus ultrices."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])]), " ", _h('article', [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic06.jpg"),
      "alt": ""
    }
  })]), " ", _h('h3', {
    staticClass: "major"
  }, ["Ante fermentum"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla dignissim dapibus ultrices."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])]), " ", _h('article', [_h('a', {
    staticClass: "image",
    attrs: {
      "href": "#"
    }
  }, [_h('img', {
    attrs: {
      "src": require("images/pic07.jpg"),
      "alt": ""
    }
  })]), " ", _h('h3', {
    staticClass: "major"
  }, ["Fusce consequat"]), " ", _h('p', ["Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla dignissim dapibus ultrices."]), " ", _h('a', {
    staticClass: "special",
    attrs: {
      "href": "#footer"
    }
  }, ["Try Now"])])]), " ", _h('ul', {
    staticClass: "actions"
  }, [_h('li', [_h('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    }
  }, ["Browse All"])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94b7bd4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 43
// module chunks = 1